(ns common.db.effects.posh
  (:require [clojure.spec.alpha :as spec]
            [common.spec]
            [re-frame.core :as rf]
            [re-frame.registrar]))

(spec/def ::event
  (spec/or
   :fn fn?
   :reframe-event :reframe/sub-or-event))

(defn dispatch!
  [ev & args]
  {:pre [(spec/assert ::event ev)]}
  (case (first (spec/conform ::event ev))
    :fn (apply ev args)
    :reframe-event (rf/dispatch (apply conj ev args))))

(rf/reg-fx :posh/transact!
  (fn [[datoms {:keys [on-error on-success]}]]
    (let [transact! (re-frame.registrar/get-handler :fx :transact)]
      (try
        (transact! datoms)
        (when on-success
          (dispatch! on-success))
        (catch js/Error e
          (when on-error
            (dispatch! on-error e)))))))
